import React, { useState, useEffect } from "react"
import { View } from "react-native";
import RechargeScreen from "./RechargeScreen";
import Benifits from "../SubComponents/TripInsurance/Benifits";
import PersonalDetails from '../SubComponents/TripInsurance/PersonalDetails'
import NomineeDetails from '../SubComponents/TripInsurance/NomineeDetails'
import UserDetails from "../SubComponents/Dashboard/UserDetails";
import RechargeBreakup from "../SubComponents/TripInsurance/RechargeBreakup";
import Header from "../common/Header";
import MobileHeader from "../common/MobileHeader";
import Sidebar from "../common/Sidebar";
import {  CreateResponsiveStyle, DEVICE_SIZES, minSize, maxSize, useDeviceSize,} from "rn-responsive-styles";
import TabHeader from "../common/TabHeader";
import ModalAlert from "../common/ModalAlert";
import { useLogin } from "../context/loginProvider";

export default function Recharge(props) {
    const styles = useStyles();
    const deviceSize = useDeviceSize()
    const [isShowSidebar, setIsShowSidebar] = useState(false);
    const [activeScreen, setActiveScreen] = useState("Recharge")
    const [data, setData] = useState({})
    const { isLoggedIn, setIsLoggedIn } = useLogin();
    const [showLogoutModal, setShowLogoutModal] =useState(false);
    const isSmallDevice = deviceSize === "small" || deviceSize === "extrasmall"
   
    console.log(props, 'props33')
    useEffect(() => {
        if (props?.route?.params) {
            const reqObject = { ...props?.route?.params.rechargeSelectedVehicle, fromTagClosure: true }
            setData({ ...reqObject })
            setActiveScreen("Recharge")


        } else {

            setActiveScreen("Recharge")
        }
    }, [props]);

    function renderSwitch() {
        switch (activeScreen) {
            case 'Recharge':
                return <RechargeScreen navigation={props.navigation} setScreen={setActiveScreen} setData={setData} data={data} />
            case 'Benifits':
                return <Benifits setScreen={setActiveScreen} setData={setData} data={data}
                    info={{
                        useCase: 'Recharge',
                        backNavigation: 'Recharge',
                        skipNavigation: 'PriceBreakup',
                        showSkipButton: true
                    }} />;
            case 'personalDetails':
                return <PersonalDetails setScreen={setActiveScreen} setData={setData} data={data} />
            case 'NomineeDetails':
                return <NomineeDetails setScreen={setActiveScreen}
                    info={{
                        proceedNavigation: 'PriceBreakup',
                        skipNavigation: 'PriceBreakup',
                    }} setData={setData} data={data} />
            case 'PriceBreakup':
                return <RechargeBreakup setScreen={setActiveScreen} setData={setData} data={data}
                    info={{
                        backNavigation: data?.insuranceSkipped ? "Benifits" : 'NomineeDetails',
                    }}
                />
            default: return <RechargeScreen navigation={props.navigation} setScreen={setActiveScreen} setData={setData} data={data} />
        }
    }

    return (
        <>
            <View style={{width:'100%'}}>
                <Header />
                <MobileHeader isShowSidebar={setIsShowSidebar} />
                <TabHeader />
                <View style={styles.mainContainer}>
                    <View style={styles.contentWidget}>
                        {!isShowSidebar && <Sidebar navigation={props.navigation} />}

                        <View style={styles.contentWrapper} >
                            <View style={styles.userDetailsWidget}>
                               {isSmallDevice ? "" :<UserDetails navigation={props.navigation} />}
                            </View>
                            {renderSwitch()}
                        </View>
                    </View>

                </View>

                {showLogoutModal ? (
                    <View style={styles.overlayViewStyle}>
                    <ModalAlert
                        title={"Error"}
                        message={global.TimeoutError}
                        actionButton={"OK"}
                        onCloseModal={() => setIsLoggedIn(false)}
                    />
                    </View>
                ) : null}
            </View>
        </>


    )
}

const useStyles = CreateResponsiveStyle(
    {
        mainContainer: {
            width: "100%",
            height: '100vh',
            flexDirection: 'row',
            justifyContent: 'center',
            paddingTop: 40,
            backgroundColor: '#f2f4f5',
            backgroundImage:
                "linear-gradient(to top, #f2f4f5, #f2f4f5 50%, #eee 50%, #333 50%);",
        },
        overlayViewStyle: {
            position: "absolute",
            zIndex: 9999,
            backgroundColor: "rgba(52,52,52,0.9)",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            borderRadius: 15,
            marginLeft: 20,
            alignItems: "center",
            justifyContent: "center",
          },
        contentWidget: {
            maxWidth: 1200,
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'center',
            paddingLeft: 80
        },
        contentWrapper: {
            width: '100%',
            marginLeft: 20
        },
        userDetailsWidget:{ 
            marginLeft: 25, 
            marginBottom: -15 
        }
    },

    {
        [maxSize(DEVICE_SIZES.SM)]: {
            contentWidget: {
                paddingLeft: 0
            },
            userDetailsWidget:{ 
                marginLeft: 15, 
                marginBottom: -5 
            }
        },

        [maxSize(DEVICE_SIZES.MD)]: {
            contentWidget: {
                paddingLeft: 10,
                width: '80%',
                maxWidth: 999,
            },
            contentWrapper: {
                marginLeft: 0
            }
        },

        [minSize(DEVICE_SIZES.LG)]: {

        },
        [DEVICE_SIZES.XS]: {
            mainContainer: {
                paddingTop: 20,
                paddingLeft: 0,

            },
            contentWidget: {
                paddingLeft: 0,
                width: '90%',
                marginLeft: -10
            },
            userDetailsWidget:{ 
                marginLeft: 15, 
                marginBottom: -5 
            }
        },
    }
);





